import { render, staticRenderFns } from "./fontStyleController.vue?vue&type=template&id=7ba34814&"
import script from "./fontStyleController.vue?vue&type=script&lang=ts&"
export * from "./fontStyleController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports